(function () {
    $("#sector-list-toggle").click(function () {
        $('#sector-list').fadeToggle('slow');
    });
    $("#sector-list-toggle-main").click(function () {
        $('#sector-list-main').fadeToggle('slow');
    });
})();